// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import PubSub from "pubsub-js";
import React from "react";
import { withRouter } from '../../utils/routerCompat';
import { Treebeard } from "./Treebeard";
import decorators from "./decorators";
import * as filters from "../../utils/filter";
import WebSockets, {
  WEBSOCKET_RETRY_EVENT,
  WEBSOCKET_RETRY_ACK,
  WEBSOCKET_GAVE_UP
} from "../websockets/WebSockets";
import Search from "../common/Search";
import customTheme from "./themes/customTheme";
import { LoaderService } from "../../services/loader.service";
import { toast } from "react-toastify";
import { treeElementTypes } from "../../constants";
import ConfirmAction from "../modal/confirm-action/ConfirmAction";
import TreeCreationModal from "./creation-modal/tree-creation-modal";
import Modal from "../modal/modal.component";
import ApiService from "../../services/api.service";
import { eventNames } from "../../constants/eventNames";
import { apiUrlConfig } from "../../constants/apiUrlConfig";
import { keyboardKeys } from "../../constants/keyboardKeys";
import { AuthService } from "../../services/auth.service";
import { dispatch, setProjectComponentUrls } from "../../utils/Extension";
import { showErrMessage } from "../../utils/common";
import PostmanCollectionUploader from "./PostmanCollectionUploader";
import SwaggerFlowImporter from "./SwaggerFlowImporter";
import PostmanEnvironmentUploader from "./PostmanEnvironmentUploader";
import NodeNameEditModal from "../component-flow/component-modal-wrapper/component-modal-node-name-edit/NodeNameEditModal";
import GitFlowModal from "../component-connection/component-modal-wrapper/component-modal-gitflow/GitFlowModal";
import GitLogModal from "../component-connection/component-modal-wrapper/component-modal-gitlog/GitLogModal";
import VirtualizationModal from "../component-connection/component-modal-wrapper/component-modal-virtualization/VirtualizationModal";

class TheTree extends React.Component {
  static updateCursor = false;
  actions = {
    contact: () => this.onEditNode(),
    projectSettings: () => this.onProjectSettings(),
    edit: () => this.onEditNode(),
    remove: () => this.onDeleteNode(),
    add: () => this.onAddNode(),
    copy: () => this.onCopyNode(),
    enable: () => this.onEnableNode(),
    disable: () => this.onDisableNode(),
    removeAll: () => this.onDeleteAllNode()
  };

  constructor(props) {
    super(props);
    this.apiService = ApiService.getInstance();
    const savedState = localStorage.getItem("treeState");
    if (savedState) {
      this.state = JSON.parse(savedState);
    } else {
      this.state = {
        webSocketsConnectedStatus: false,
        data: { name: "Projects" },
        originalData: {},
        flowId: "",
        redirect: false,
        canAdd: false,
        canRemove: false,
        canEdit: false,
        addFolder: false,
        editFolder: false,
        removeFolder: false,
        addFile: false,
        editFile: false,
        copyFile: false,
        pathname: "",
        isNodeNameModal: false,
        isGitFlowModal: false,
        isGitLogModal: false,
        isVirtualization: false,
        addedNodeId: "",
        removedAll: false,
        importPostmanCollectionModal: false,
        importPostmanVariablesModal: false,
        importSwaggerFlowsModal: false,
      };
    }
    this.onToggle = this.onToggle.bind(this);
    this.find = this.find.bind(this);
    this.handleOnKeyUp = this.handleOnKeyUp.bind(this);
    this.onWebSocketsChangeConnectedStatus = this.onWebSocketsChangeConnectedStatus.bind(this);
    this.tempNestedTreeElems = [];
    this.prevToggledItemsID = {};
    this._pubsubTokens = [];
    const closeModalKey = PubSub.subscribe(eventNames.globalKeyUp, (eventName, event) => {
      if (event.keyCode === keyboardKeys.esc) {
        this.closeModal();
      }
    });
    this._pubsubTokens.push(closeModalKey);
    this._isMounted = false;
  }

  async componentDidMount() {
    this._isMounted = true;
    var asideHolder = document.getElementsByClassName("aside-holder");
    if (asideHolder.length > 0) {
      asideHolder[0].addEventListener("pointerdown", e => {
        e.stopPropagation();
      });
    }
    // Check if another page (e.g., TCM flow generation) flagged that the tree needs a fresh reload
    if (sessionStorage.getItem("treeNeedsRefresh") === "true") {
      console.log("[TheTree] treeNeedsRefresh flag detected — will force fresh data from server");
      sessionStorage.removeItem("treeNeedsRefresh");
      // Clear any stale childrenLoaded cache so loadData fetches fresh children
      if (this.state.data?.children) {
        this.state.data.children.forEach(project => {
          if (project.params) {
            project.params.childrenLoaded = false;
            project.children = [];
          }
        });
      }
    }
    await this.loadData();
    this.subscribeOnItemSelect();
    this.subscribeOnUpdates();
    this._pubsubTokens.push(PubSub.subscribe(eventNames.fileUploadUpdateTree, () => {
      // Clear childrenLoaded cache so loadData fetches fresh children including newly created APIs
      if (this.state.data?.children) {
        this.state.data.children.forEach(project => {
          if (project.params) {
            project.params.childrenLoaded = false;
            project.children = [];
          }
        });
      }
      this.loadData();
    }));
    this._pubsubTokens.push(
      PubSub.subscribe(eventNames.updateTreeDataForScript, (msg, data) => this.updateTreeData(data))
    );
    this._pubsubTokens.push(
      PubSub.subscribe(eventNames.treeNodeName, (msg, data) => this.setState({ isNodeNameModal: true, nodeData: data }))
    );
    // 🐛 2026-09-02 REVIEW-GAP #4: surface a toast when the backend websocket
    // gives up its auto-reconnect. Otherwise a user on a non-flow view
    // (project settings, TCM, groups) sees stale data indefinitely without
    // any indication that the connection is permanently dead.
    this._pubsubTokens.push(
      PubSub.subscribe(WEBSOCKET_GAVE_UP, () => {
        if (!this._isMounted) return;
        toast.warn(
          ({ closeToast }) => (
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span>Live updates stopped. Your view might be stale until you reconnect.</span>
              <button
                type="button"
                onClick={() => {
                  PubSub.publish(WEBSOCKET_RETRY_EVENT);
                  if (closeToast) closeToast();
                }}
                style={{
                  padding: "4px 10px",
                  background: "#fff",
                  color: "#e65100",
                  border: "1px solid #e65100",
                  borderRadius: 4,
                  cursor: "pointer",
                  fontWeight: 600
                }}
              >
                Retry
              </button>
            </div>
          ),
          {
            autoClose: false, // sticky — user must dismiss or retry
            toastId: "websocket-gave-up"
          }
        );
      })
    );
    this._pubsubTokens.push(
      PubSub.subscribe(eventNames.treeGitFlow, (msg, data) => this.setState({ isGitFlowModal: true, nodeData: data }))
    );
    this._pubsubTokens.push(
      PubSub.subscribe(eventNames.treeVirtualization, (msg, data) =>
        this.setState({ isVirtualization: true, nodeData: data })
      )
    );
    this._pubsubTokens.push(
      PubSub.subscribe(eventNames.treeGitLog, (msg, data) => this.setState({ isGitLogModal: true, nodeData: data }))
    );
    this._pubsubTokens.push(PubSub.subscribe(eventNames.removeJSFile, () => this.loadData()));
    this._pubsubTokens.push(PubSub.subscribe(eventNames.editeTreeName, () => this.loadData()));
    this._pubsubTokens.push(PubSub.subscribe(eventNames.gitFlowEvent, () => this.loadData()));
    this._pubsubTokens.push(PubSub.subscribe(eventNames.virtualizationEvent, () => this.loadData()));
    this._pubsubTokens.push(PubSub.subscribe(eventNames.refreshTree, (msg, data) => {
      // Support forceReloadChildren flag to clear lazy-load cache
      // This is needed when new components are created (e.g., AI generation)
      // and the tree needs to fetch fresh children from the server
      if (data?.forceReloadChildren && this.state.data?.children) {
        this.state.data.children.forEach(project => {
          if (project.params) {
            project.params.childrenLoaded = false;
            project.children = [];
          }
        });
        console.info('[TheTree] Cleared childrenLoaded cache for all projects (forceReloadChildren)');
      }
      this.loadData(false);
    }));
    this._pubsubTokens.push(
      PubSub.subscribe(eventNames.treeUpdateDatasource, (msg, data) => {
        this.handleTreeUpdateDatasource(data);
      })
    );
    document.addEventListener("mousedown", this.handleClickOutside);
    if (this._isMounted) {
      this.setState({ modalShow: false });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.pathname !== nextProps.match.path) {
      const { match } = nextProps;
      TheTree.updateCursor = true;
      return { pathname: match.path };
    }
    return null;
  }

  async handleTreeUpdateDatasource(data) {
    // Step 1: Check if data & children exist
    if (!this.state || !this.state.data || !Array.isArray(this.state.data.children)) {
      console.warn("State or children not available");
      return;
    }

    // Validate componentId before making API calls
    if (!data.componentId || data.componentId === "undefined") {
      console.warn("Invalid componentId provided:", data.componentId);
      return;
    }

    let projects = this.state.data.children;

    // Step 2: Find the matching project
    let project = projects.find(p => p.id === data.projectId);
    if (!project || !Array.isArray(project.children)) {
      console.warn("Project or its children not found");
      return;
    }

    // Step 3: Find the component node
    let componentNode = project.children.find(pc => pc.contentType === "component");
    if (!componentNode) {
      console.warn("Component node not found");
      return;
    }

    componentNode.toggled = true;

    // Step 4: Try to find the component
    let component = Array.isArray(componentNode.children)
      ? componentNode.children.find(c => c.id === data.componentId)
      : undefined;

    const isExists = !!component;

    try {
      if (isExists) {
        const res = await this.apiService.get(apiUrlConfig.projectByIdAndComponentId(data.projectId, data.componentId));

        if (res && res.payload && res.payload.length > 0) {
          component.dependencies = res.payload[0].dependencies;
        }
      } else {
        // Load components into componentNode
        const result = await this.apiService.get(apiUrlConfig.projectByIdAndContentType(data.projectId, "component"));

        componentNode.children = (result && result.payload) || [];

        componentNode.children.forEach(child => {
          child.projectID = data.projectId;
          child.groupID = componentNode.id;
        });

        // Notify extension of all component URLs so it can suppress "New web page" modal for known pages
        setProjectComponentUrls(componentNode.children);

        // Try again to find the component after reloading children
        const res = await this.apiService.get(apiUrlConfig.projectByIdAndComponentId(data.projectId, data.componentId));

        component = componentNode.children.find(c => c.id === data.componentId);

        if (component && res && res.payload && res.payload.length > 0) {
          component.dependencies = res.payload[0].dependencies;
        }
      }

      // Step 5: Trigger re-render
      if (this._isMounted) {
        this.setState({
          data: { ...this.state.data }
        });
      }
    } catch (error) {
      console.error("Error while loading component data:", error);
    }
  }

  componentDidUpdate = () => {
    localStorage.setItem("treeState", JSON.stringify(this.state));
    if (TheTree.updateCursor && this.state.data && this.state.data.children) {
      this.getCursorById(this.props.match.params.id);
      TheTree.updateCursor = false;
    }
  };

  handleImportFromPostmanCollection = () => {};

  setPostmanModalOpen = type => {
    if (type === "api") {
      this.setState({ importPostmanCollectionModal: true });
    } else if (type === "variable") {
      this.setState({ importPostmanVariablesModal: true });
    }
  };

  // Swagger FLOW import: multi-step sequences, not one API per endpoint.
  setSwaggerFlowModalOpen = () => {
    this.setState({ importSwaggerFlowsModal: true });
  };

  // The importer creates the APIs itself, so there is nothing to post
  // here -- only the tree to refresh so they appear. Same refresh
  // addBulkApis uses: the lazy-load cache has to be cleared first, or
  // the new APIs exist on the server and stay invisible in the tree.
  // Same refresh as a flow import, different wording: the uploader has
  // already reported what it created, so this only makes it visible.
  onConfigImported = created => {
    this.closeModal();
    if (this.state.data?.children) {
      this.state.data.children.forEach(project => {
        if (project.params) {
          project.params.childrenLoaded = false;
          project.children = [];
        }
      });
    }
    const count = created ? created.length : 0;
    setTimeout(() => {
      this.loadData(true, `${count} variable set${count === 1 ? "" : "s"} created!`);
    }, 1000);
  };

  onSwaggerFlowsCreated = created => {
    this.closeModal();
    if (this.state.data?.children) {
      this.state.data.children.forEach(project => {
        if (project.params) {
          project.params.childrenLoaded = false;
          project.children = [];
        }
      });
    }
    const count = created ? created.length : 0;
    setTimeout(() => {
      this.loadData(true, `${count} flow${count === 1 ? "" : "s"} created!`);
    }, 1000);
  };

  getCursorById = async id => {
    const { data } = this.state;
    console.log('[TheTree] getCursorById called with id:', id);

    // First try to find the node directly
    this.cursor = null;
    this.getSelectedElementData(data, id);

    // If node found, activate it
    if (this.cursor && id) {
      console.log('[TheTree] Node found directly, activating:', this.cursor.name);
      this.onToggle(this.cursor, true);
      return;
    }

    // Node not found - likely due to lazy loading
    // Try to load the necessary project and group children from URL params
    console.log('[TheTree] Node not found, trying lazy load...');
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const projectId = urlParams.get('project');
      const groupId = urlParams.get('group');
      console.log('[TheTree] URL params - projectId:', projectId, 'groupId:', groupId);

      if (!projectId || !data || !data.children) {
        console.log('[TheTree] Missing projectId or data, aborting');
        return;
      }

      // Find the project in the tree
      const project = data.children.find(p => p.id === projectId);
      if (!project) {
        console.log('[TheTree] Project not found in tree');
        return;
      }
      console.log('[TheTree] Found project:', project.name, 'childrenLoaded:', project.params?.childrenLoaded);

      // Load project children if not loaded yet
      if (!project.params?.childrenLoaded) {
        const res = await this.apiService.get(apiUrlConfig.projectsBasicDetail(projectId));
        if (res.success && res.payload && res.payload.children) {
          // Filter out Virtualization and unwanted groups
          const filteredChildren = res.payload.children.filter(child => {
            if (child.name === "Virtualization") return false;
            return true;
          });
          filteredChildren.forEach(child => {
            child.projectID = projectId;
            child.groupID = child.id;
            child.children = child.children || [];
          });
          project.children = filteredChildren;
          if (!project.params) project.params = {};
          project.params.childrenLoaded = true;
          project.toggled = true;
        }
      }

      // Find the group and load its children if needed
      if (groupId && project.children) {
        const group = project.children.find(g => g.id === groupId);
        if (group && (!group.children || group.children.length === 0) && !group.params?.childrenLoaded) {
          const result = await this.apiService.get(apiUrlConfig.projectByIdAndContentType(projectId, group.contentType));
          if (result.success && result.payload) {
            const children = result.payload;
            children.forEach(child => {
              child.projectID = projectId;
              child.groupID = groupId;
            });
            group.children = children;
            if (!group.params) group.params = {};
            group.params.childrenLoaded = true;
            group.toggled = true;

            // Notify extension of component URLs when component group is loaded
            if (group.contentType === "component") {
              setProjectComponentUrls(children);
            }
          }
        }
      }

      // Update state and try to find the node again
      if (this._isMounted) {
        this.setState({ data: { ...data } }, () => {
          this.cursor = null;
          this.getSelectedElementData(this.state.data, id);
          if (this.cursor && id) {
            this.onToggle(this.cursor, true);
          }
        });
      }
    } catch (error) {
      console.error('[TheTree] Error in getCursorById lazy loading:', error);
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
    if (this._pubsubTokens && this._pubsubTokens.length > 0) {
      this._pubsubTokens.forEach(token => PubSub.unsubscribe(token));
      this._pubsubTokens = [];
    }
    this.subscriberGroupSelect && PubSub.unsubscribe(this.subscriberGroupSelect);
    this.subscriberUpdateTree && PubSub.unsubscribe(this.subscriberUpdateTree);
    this.subscriberRefreshTree && PubSub.unsubscribe(this.subscriberRefreshTree);
    this.subscriberRefreshCurrentComponent && PubSub.unsubscribe(this.subscriberRefreshCurrentComponent);
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  addParentNodeIds(treeItems) {
    treeItems.forEach(item => {
      if (this.prevToggledItemsID[item.id]) item.toggled = true;
      if (item.children) {
        if (item.elementType === treeElementTypes.project) {
          item.children.forEach(group => (group.projectID = item.id));
        }
        if (item.elementType === treeElementTypes.group) {
          item.groupID = item.id;
        }
        if (item.elementType === treeElementTypes.group) {
          item.groupID = item.id;
        }
        if (
          item.elementType === treeElementTypes.group ||
          item.elementType === treeElementTypes.flow ||
          item.elementType === treeElementTypes.connection ||
          item.elementType === treeElementTypes.script /*||
          item.elementType === treeElementTypes.report*/
        ) {
          item.children.forEach(file => {
            file.projectID = item.projectID;
            file.groupID = item.id;
          });
        }
        this.addParentNodeIds(item.children);
      }
    });
  }

  expandTree(treeItems = this.state.data.children, isNested) {
    treeItems.forEach(item => {
      if ((item.children && this.isSomeToggled(item.children)) || item.toggled) {
        this.tempNestedTreeElems.push(item);
      }
      if (item.children) {
        this.expandTree(item.children, true);
      }
      if (!isNested) {
        const deepestToggledElemIndex = this.tempNestedTreeElems.map(item => item.toggled).lastIndexOf(true);
        if (deepestToggledElemIndex !== -1) {
          this.tempNestedTreeElems = this.tempNestedTreeElems.slice(0, deepestToggledElemIndex + 1).map(item => {
            item.toggled = true;
            return item;
          });
        }
        this.tempNestedTreeElems = [];
      }
    });
  }

  isSomeToggled(items) {
    return items.some(item => item.toggled || (item.children && this.isSomeToggled(item.children)));
  }

  deactivateCursor() {
    const cursor = this.state.cursor;
    if (cursor) {
      cursor.active = false;
    }
    let isUpdated = false;
    let updatedData = this.state.data;
    if (updatedData && updatedData.children && updatedData.children.length > 0) {
      updatedData.children.forEach(child => {
        if (child.id === cursor.projectID) {
          if (child.children && child.children.length > 0) {
            child.children.forEach(grandChild => {
              if (
                grandChild.contentType &&
                cursor.elementType &&
                grandChild.contentType.toLowerCase() === cursor.elementType.toLowerCase()
              ) {
                if (grandChild.children && grandChild.children.length > 0) {
                  grandChild.children.forEach(node => {
                    if (node.name === cursor.name) {
                      node.active = false;
                      isUpdated = true;
                    }
                  });
                }
              }
            });
          }
        }
      });
    }
    if (this._isMounted) {
      this.setState({
        data: updatedData
      });
    }
    if (isUpdated) {
      PubSub.publish(eventNames.treeUpdated, updatedData.children);
    }
  }

  updateTreeData(data) {
    let res = data.data;
    let componentId = data.nodeId;
    let originalData = this.state.originalData;
    let originalDataChildren = originalData.children;
    let currentProject = originalDataChildren.find(project => {
      if (project.children.find(child => child.id === res.payload.group.id)) return project;
      return false;
    });
    let projectChildren = currentProject && currentProject.children;
    for (let i = 0; i < projectChildren.length; i++) {
      let projectChild = projectChildren[i];
      if (projectChild.name === "Components") {
        let projComponents = projectChild.children;
        let currentComponent = projComponents.find(comp => {
          return comp.id === componentId;
        });
        let dependencies = currentComponent.dependencies;
        dependencies = dependencies && dependencies.length > 0 ? dependencies : [];
        let isExistsScript = false;
        for (let j = 0; j < dependencies.length; j++) {
          if (dependencies[j].elementType === "SCRIPT") {
            isExistsScript = true;
          }
        }
        if (!isExistsScript) {
          dependencies.push({
            elementType: "SCRIPT",
            id: res.payload.id,
            name: res.payload.name,
            groupID: res.payload.group.id,
            projectID: currentProject.id
          });
        }
        projectChildren.children = projComponents;
      } else if (projectChild.name === "Scripts") {
        let projScripts = projectChild.children;
        projScripts = projScripts && projScripts.length > 0 ? projScripts : [];
        projScripts.push({
          elementType: "SCRIPT",
          id: res.payload.id,
          name: res.payload.name,
          groupID: res.payload.group.id,
          projectID: currentProject.id
        });
        projectChild.children = projScripts;
      }
    }
    originalData.children = originalDataChildren;

    if (this._isMounted) {
      this.setState(
        {
          originalData: originalData,
          data: originalData,
          addedNodeId: data.nodeId
        },
        () => {
          this.activateAddedNode();
        }
      );
    }

    PubSub.publish(eventNames.treeUpdated, originalDataChildren);
  }

  async loadData(showActiveNode = true, message = null) {
    LoaderService.showTreeComLoading();
    try {
      await this.dataGetRequest(showActiveNode);
      if (message !== null) {
        toast.success(message);
      }
    } catch (e) {
      showErrMessage(e);
    } finally {
      LoaderService.hide();
      LoaderService.hideTreeComLoading();
    }
  }

  dataGetRequest(showActiveNode) {
    // Use lazy loading endpoint - only fetch project names without children
    // Children will be loaded on demand when project is expanded

    return this.apiService
      .get(apiUrlConfig.projectListLazy())
      .then(res => {
        if (res.success) {
          // Get existing projects from current state to preserve lazy-loaded children
          const existingProjects = this.state.data?.children || [];
          const existingProjectsMap = {};
          existingProjects.forEach(p => {
            existingProjectsMap[p.id] = p;
          });

          // Projects come without children (children=[], childrenLoaded=false)
          // But we need to preserve existing children if they were lazy-loaded
          const modifiedPayload = res.payload.map(project => {
            const existingProject = existingProjectsMap[project.id];

            // If this project was already loaded with children, preserve them
            if (existingProject && existingProject.params?.childrenLoaded) {
              // Preserve children and toggled state
              project.children = existingProject.children;
              project.params = existingProject.params;
              project.toggled = existingProject.toggled;
              console.log("[TREE DEBUG] Preserving existing children for project:", project.name, "children:", project.children?.length);
            } else {
              // Set empty children array if not present
              if (!project.children) {
                project.children = [];
              }
              // Mark that children haven't been loaded yet
              if (!project.params) {
                project.params = {};
              }
              project.params.childrenLoaded = false;
            }
            return project;
          });

          const treeData = {
            name: "Projects",
            elementType: treeElementTypes.root,
            toggled: true,
            children: modifiedPayload
          };
          const data = res.payload[res.payload.length - 1];
          this.addParentNodeIds(res.payload);
          this.deactivateCursor();
          if (this._isMounted) {
            this.setState(
              {
                originalData: treeData,
                data: treeData,
                cursor: treeData,
                addedNodeId: this.state.isCreatedProject ? data.id : this.state.addedNodeId
              },
              () => {
                if (showActiveNode) {
                  this.activateAddedNode();
                } else if (this.state.actionElement) {
                  this.activateCurrentNode();
                }
                // On initial load/refresh, try to restore active node from URL
                // Parse node ID from URL pathname (e.g., /api/123 or /work-flows/456)
                const pathParts = window.location.pathname.split('/');
                const nodeId = pathParts.length >= 3 ? pathParts[pathParts.length - 1] : null;
                // Only restore if nodeId looks like a valid MongoDB ObjectId (24 hex chars)
                const isValidId = nodeId && /^[a-f0-9]{24}$/i.test(nodeId);
                // Only restore if cursor is not already set to the correct node
                const cursorId = this.state.cursor?.id;
                const needsRestore = isValidId && (!cursorId || cursorId === 'Projects' || cursorId !== nodeId);
                console.log('[TheTree] URL restore check:', { nodeId, isValidId, cursorId, needsRestore });
                if (needsRestore) {
                  console.log('[TheTree] Restoring active node from URL:', nodeId);
                  this.getCursorById(nodeId);
                }
              }
            );
            this.setControlsVisibility({});
            PubSub.publish(eventNames.treeUpdated, modifiedPayload);
          }
        } else {
          if (res.error) {
            showErrMessage(res);
          }
          if (res.message) {
            toast.error(res.message);
          }
        }
      })
      .catch(error => {
        toast.error(error.message);
      })
      .finally(() => {
        LoaderService.hide();
        LoaderService.hideTreeComLoading();
      });
  }

  activateCurrentNode = () => {
    const { actionElement } = this.state;
    if (actionElement && actionElement !== "") {
      let cursor;
      const nodeFind = node => {
        if (node.id === actionElement.id) {
          cursor = node;
          return node;
        } else {
          if (node.children) {
            let found;
            node.children.forEach(elem => {
              found = nodeFind(elem);
            });
            if (found && found !== null) {
              node.toggled = true;
              return node;
            } else {
              return null;
            }
          } else {
            return null;
          }
        }
      };
      let newData = nodeFind(this.state.data);
      // if (cursor) {
      //   this.deactivateCursor();
      //   cursor.active = true;
      //   cursor.toggled = true;
      //   this.setState({ cursor });
      // }
      if (newData !== null) {
        if (this._isMounted) {
          this.setState({ data: newData });
        }
        this.onToggle(cursor, true);
        this.openActiveElement(cursor);
      }
    }
    return;
  };

  activateAddedNode = () => {
    const { addedNodeId } = this.state;
    if (addedNodeId && addedNodeId !== "") {
      let cursor;
      const nodeFind = node => {
        if (node.id === addedNodeId) {
          cursor = node;
          return node;
        } else {
          if (node.children) {
            let found;
            node.children.forEach(elem => {
              found = nodeFind(elem);
            });
            if (found && found !== null) {
              node.toggled = true;
              return node;
            } else {
              return null;
            }
          } else {
            return null;
          }
        }
      };
      let newData = nodeFind(this.state.data);
      // if (cursor) {
      //   cursor.active = true;
      //   cursor.toggled = true;
      //   this.setState({ cursor });
      // }
      if (newData !== null) {
        if (this._isMounted) {
          this.setState({ data: newData });
        }
        this.onToggle(cursor, true);
        this.openActiveElement(cursor);
      }
    }
    return;
  };

  subscribeOnItemSelect() {
    this.subscriberGroupSelect = PubSub.subscribe(eventNames.groupSelect, (event, data) => {
      let currentGroup;
      let currentFile;
      let { cursor } = this.state;
      cursor.active = false;
      this.state.data.children.forEach(project => {
        if (!currentGroup) {
          currentGroup = project.children.find(group => group.id === data.groupId);
        }
      });
      if (currentGroup) {
        currentFile = currentGroup.children.find(file => file.id === data.fileId);
      }
      cursor = currentFile || currentGroup;
      if (!cursor) return;
      cursor.toggled = true;
      cursor.active = true;
      this.prevToggledItemsID[cursor.id] = cursor.id;
      if (this._isMounted) {
        this.setState({ cursor });
      }
      this.expandTree();
      PubSub.publish(eventNames.selectTreeGroup, currentGroup.children);
    });
  }

  subscribeOnUpdates() {
    this.subscriberUpdateTree = PubSub.subscribe(eventNames.updateTree, (msg, callback = () => {}) => {
      if (typeof callback === "function") {
        let data = callback();
        if (data && data.component_id) {
          if (this._isMounted) {
            this.setState({
              addedNodeId: data.component_id
            });
          }
        }
      }
      this.updateTree(callback);
    });
    this.subscriberRefreshCurrentComponent = PubSub.subscribe("refreshCurrentComponent", () => {
      this.openActiveElement();
    });
  }

  async updateTree(callback) {
    let data = callback ? callback() : null;
    if (data && data.component_id) {
      await this.loadData(true);
    } else {
      await this.loadData(false);
    }
    this.expandTree();
    if (callback) {
      callback();
    }
  }

  async onToggle(node, toggled) {
    console.log("[TREE DEBUG] onToggle called", {
      nodeName: node?.name,
      nodeId: node?.id,
      elementType: node?.elementType,
      toggled,
      currentToggled: node?.toggled,
      childrenCount: node?.children?.length
    });

    if (
      !this.state.webSocketsConnectedStatus &&
      (node !== undefined &&
        node !== null &&
        node.contentType !== undefined &&
        node.contentType !== null &&
        (node.contentType === "flow" || node.elementType === "FLOW"))
    ) {
      console.log("[TREE DEBUG] Early return: Websocket not connected");
      // 🐛 2026-09-02 RETRY-BUTTON: previously this toast just told the user
      // the socket was gone with no recovery path — a hard page reload was
      // the only way back. The toast now carries a Retry button that
      // publishes WEBSOCKET_RETRY_EVENT, which WebSockets.tsx handles by
      // resetting the auto-retry counter and reconnecting immediately.
      return toast.error(
        ({ closeToast }) => (
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span>Can't open this flow — live updates aren't connected.</span>
            <button
              type="button"
              onClick={() => {
                // 🐛 2026-09-02 REVIEW-GAP #7: PubSub.publish returns false
                // when no subscriber exists — happens if this toast survives
                // a route change that unmounted the WebSockets component.
                // Fall back to a page reload prompt in that case so the user
                // isn't stranded with a Retry button that silently no-ops.
                //
                // 🐛 2026-09-02 REVIEW-GAP #2: also subscribe to the ACK
                // event so the user always sees what happened to their
                // click. Previously a click during an in-flight reconnect
                // dismissed the toast and did nothing else — silent no-op.
                const ackToken = PubSub.subscribeOnce
                  ? PubSub.subscribeOnce(WEBSOCKET_RETRY_ACK, (_msg, outcome) => {
                      if (outcome === "accepted") {
                        toast.info("Reconnecting…", { toastId: "websocket-retry-in-progress", autoClose: 3500 });
                      } else if (outcome === "in-flight") {
                        toast.info("Reconnect already in progress — hang on.", { toastId: "websocket-retry-in-progress", autoClose: 3500 });
                      } else {
                        toast.warn("Retry failed to start — please refresh the page.", { toastId: "websocket-retry-undelivered" });
                      }
                    })
                  : (() => {
                      // pubsub-js versions without subscribeOnce — subscribe + unsubscribe ourselves
                      const t = PubSub.subscribe(WEBSOCKET_RETRY_ACK, (_msg, outcome) => {
                        PubSub.unsubscribe(t);
                        if (outcome === "accepted") {
                          toast.info("Reconnecting…", { toastId: "websocket-retry-in-progress", autoClose: 3500 });
                        } else if (outcome === "in-flight") {
                          toast.info("Reconnect already in progress — hang on.", { toastId: "websocket-retry-in-progress", autoClose: 3500 });
                        } else {
                          toast.warn("Retry failed to start — please refresh the page.", { toastId: "websocket-retry-undelivered" });
                        }
                      });
                      return t;
                    })();
                const delivered = PubSub.publish(WEBSOCKET_RETRY_EVENT);
                if (closeToast) closeToast();
                if (!delivered) {
                  PubSub.unsubscribe(ackToken);
                  toast.warn(
                    "Retry couldn't be delivered — please refresh the page to reconnect.",
                    { toastId: "websocket-retry-undelivered" }
                  );
                }
              }}
              style={{
                padding: "4px 10px",
                background: "#fff",
                color: "#d32f2f",
                border: "1px solid #d32f2f",
                borderRadius: 4,
                cursor: "pointer",
                fontWeight: 600
              }}
            >
              Retry
            </button>
          </div>
        ),
        {
          autoClose: 8000,
          // 🐛 2026-09-02 REVIEW-GAP #4: dedup — repeated flow-node clicks
          // while disconnected used to stack identical toasts. A fixed
          // toastId makes react-toastify skip re-renders of the same id.
          toastId: "websocket-connection-lost"
        }
      );
    }

    if (node === undefined || node === null || node.elementType === undefined || node.elementType === null) {
      console.log("[TREE DEBUG] Early return: node or elementType is undefined/null");
      return;
    }

    const { cursor } = this.state;

    // Early return if clicking the same active node (except for groups/projects which need toggle)
    if (node.id === cursor.id && node.toggled && node.elementType !== "GROUP" && node.elementType !== "PROJECT") {
      console.log("[TREE DEBUG] Early return: same active node clicked");
      return;
    }

    let isUpdated = false;

    // Load children for projects without children (lazy loading)
    // Check if it's a PROJECT with no children OR children not loaded yet
    const needsChildrenLoad = node &&
      node.elementType === treeElementTypes.project &&
      (!node.children || node.children.length === 0 || (node.params && node.params.childrenLoaded === false));

    console.log("[TREE DEBUG] needsChildrenLoad:", needsChildrenLoad, {
      elementType: node.elementType,
      projectType: treeElementTypes.project,
      hasChildren: !!node.children,
      childrenLength: node.children?.length,
      childrenLoaded: node.params?.childrenLoaded
    });

    if (needsChildrenLoad) {
      console.log("[TREE DEBUG] Loading children for project:", node.id);
      try {
        let result = await this.apiService.get(apiUrlConfig.projectsBasicDetail(node.id));
        console.log("[TREE DEBUG] API result:", result);
        if (result && result.payload) {
          let projectData = result.payload;
          // Filter out Virtualization and unwanted reports
          let filteredChildren = (projectData.children || []).filter(child => {
            // Filter out Virtualization group
            if (child.name === "Virtualization") {
              return false;
            }
            // Filter out Reports group or filter specific reports
            if (child.name === "Reports" && child.children) {
              // Filter the reports children to only keep desired ones
              child.children = child.children.filter(report => {
                return report.name === "Automation Cost Saving" ||
                       report.name === "Automation Test Creation" ||
                       report.name === "Result Mapper";
              });
            }
            return true;
          });

          console.log("[TREE DEBUG] Filtered children:", filteredChildren.map(c => ({ name: c.name, elementType: c.elementType, contentType: c.contentType, id: c.id })));

          // Add projectID to each group child and ensure groupID is set
          filteredChildren.forEach(group => {
            group.projectID = node.id;
            group.groupID = group.id; // Set groupID for group nodes
            // Groups don't have children loaded yet - they use their own lazy loading
            if (group.elementType === treeElementTypes.group) {
              group.children = group.children || [];
              // If group already has children from API, set their projectID and groupID
              if (group.children && group.children.length > 0) {
                group.children.forEach(file => {
                  file.projectID = node.id;
                  file.groupID = group.id;
                });
              }
            }
            console.log("[TREE DEBUG] Set group props:", { name: group.name, projectID: group.projectID, groupID: group.groupID, contentType: group.contentType, elementType: group.elementType });
          });

          node.children = filteredChildren;
          // Mark children as loaded to prevent re-fetching
          if (!node.params) {
            node.params = {};
          }
          node.params.childrenLoaded = true;
          isUpdated = true;
          console.log("[TREE DEBUG] Children loaded, isUpdated:", isUpdated, "node.children:", node.children?.length);
        }
      } catch (error) {
        console.error("[TREE DEBUG] Error loading project children:", error);
      }
    }

    // Load children for groups without children (lazy loading)
    console.log("[TREE DEBUG] Group check:", {
      elementType: node?.elementType,
      groupType: treeElementTypes.group,
      isGroup: node?.elementType === treeElementTypes.group,
      projectID: node?.projectID,
      contentType: node?.contentType,
      hasChildren: !!node?.children,
      childrenLength: node?.children?.length
    });

    // Check if group needs loading - has no children AND hasn't been loaded yet
    const needsGroupChildrenLoad = node &&
      node.elementType === treeElementTypes.group &&
      node.projectID &&
      (!node.children || node.children.length === 0) &&
      (!node.params || node.params.childrenLoaded !== true);

    if (needsGroupChildrenLoad) {
      console.log("[TREE DEBUG] Loading GROUP children for:", node.name, "projectID:", node.projectID, "contentType:", node.contentType);
      try {
        let result = await this.apiService.get(apiUrlConfig.projectByIdAndContentType(node.projectID, node.contentType));
        console.log("[TREE DEBUG] GROUP API result:", result);
        let children = result && result.payload ? result.payload : [];
        children.forEach(file => {
          file.projectID = node.projectID;
          file.groupID = node.id;
        });
        node.children = children;
        // Mark as loaded to prevent re-fetching (even if empty)
        if (!node.params) {
          node.params = {};
        }
        node.params.childrenLoaded = true;
        isUpdated = true;
        console.log("[TREE DEBUG] GROUP children loaded:", children.length);

        // Notify extension of component URLs when component group is expanded
        if (node.contentType === "component") {
          setProjectComponentUrls(children);
        }
      } catch (error) {
        console.error("[TREE DEBUG] Error loading GROUP children:", error);
      }
    }

    // Deactivate current cursor without triggering setState
    if (cursor) {
      cursor.active = false;
    }

    // Set new node as active
    node.active = true;
    // Only toggle PROJECT and GROUP nodes - leaf nodes should not affect toggle state
    const isToggleableNode = node.elementType === treeElementTypes.project ||
                              node.elementType === treeElementTypes.group ||
                              node.elementType === treeElementTypes.root;
    if (isToggleableNode) {
      node.toggled = toggled;
    }
    node.selectedProjectId = node.projectID || node.id;

    // For leaf nodes, ensure parent nodes stay expanded
    // Find and keep parent project and group toggled
    if (!isToggleableNode) {
      const projects = this.state.data?.children || [];
      let parentProject = null;
      let parentGroup = null;

      console.log("[TREE DEBUG] Looking for parent of leaf node:", {
        nodeId: node.id,
        nodeName: node.name,
        nodeProjectID: node.projectID,
        nodeGroupID: node.groupID,
        projectsCount: projects.length
      });

      // Try to find parent using projectID if available
      if (node.projectID) {
        parentProject = projects.find(p => p.id === node.projectID);
        if (parentProject && node.groupID && parentProject.children) {
          parentGroup = parentProject.children.find(g => g.id === node.groupID);
        }
        console.log("[TREE DEBUG] Found parent by projectID:", {
          parentProjectFound: !!parentProject,
          parentProjectToggled: parentProject?.toggled,
          parentGroupFound: !!parentGroup,
          parentGroupToggled: parentGroup?.toggled
        });
      }

      // Fallback: search tree if projectID not set (can happen with certain data loads)
      if (!parentProject) {
        console.log("[TREE DEBUG] projectID not found, searching tree...");
        // Search all projects and groups to find the node
        for (const project of projects) {
          if (project.children) {
            for (const group of project.children) {
              if (group.children && group.children.some(child => child.id === node.id)) {
                parentProject = project;
                parentGroup = group;
                // Also set projectID and groupID on the node for future lookups
                node.projectID = project.id;
                node.groupID = group.id;
                console.log("[TREE DEBUG] Found parent by tree search:", {
                  parentProjectId: project.id,
                  parentProjectToggled: project.toggled,
                  parentGroupId: group.id,
                  parentGroupToggled: group.toggled
                });
                break;
              }
            }
            if (parentProject) break;
          }
        }
      }

      // Keep parent nodes toggled
      if (parentProject) {
        console.log("[TREE DEBUG] Setting parent toggled states to true");
        parentProject.toggled = true;
        if (parentGroup) {
          parentGroup.toggled = true;
        }
      } else {
        console.log("[TREE DEBUG] WARNING: No parent found for leaf node!");
      }
    }
    console.log("[TREE DEBUG] After setting node state:", {
      nodeToggled: node.toggled,
      toggledParam: toggled,
      nodeChildren: node.children?.length,
      nodeActive: node.active,
      isToggleableNode
    });
    // Only track toggle state for toggleable nodes
    if (isToggleableNode) {
      this.prevToggledItemsID[node.id] = toggled && node.id;
    }

    // Calculate control visibility values to batch with cursor setState
    let canAdd = false;
    let canEdit = false;
    let canRemove = false;

    if (node.elementType === treeElementTypes.root) {
      canAdd = true;
    } else if (node.elementType === treeElementTypes.project) {
      canEdit = true;
      canRemove = true;
    } else if (node.elementType === treeElementTypes.group) {
      canAdd = true;
      canEdit = true;
    } else if (this.checkIsFile(node.elementType)) {
      canEdit = true;
      canRemove = true;
    } else if (
      node.elementType === treeElementTypes.script ||
      node.elementType === treeElementTypes.flow ||
      node.elementType === treeElementTypes.connection ||
      node.elementType === treeElementTypes.api ||
      node.elementType === treeElementTypes.graphql ||
      node.elementType === treeElementTypes.projectuser
    ) {
      canAdd = true;
      canEdit = true;
      canRemove = true;
    }

    // Single batched setState for cursor, actionElement, and control visibility
    // When children are loaded (isUpdated), we need to update data to trigger re-render
    console.log("[TREE DEBUG] Before setState:", {
      isMounted: this._isMounted,
      isUpdated,
      dataChildrenCount: this.state.data?.children?.length
    });
    if (this._isMounted) {
      if (isUpdated) {
        console.log("[TREE DEBUG] Calling setState with data update");
        // Force re-render by creating new data reference
        this.setState({
          cursor: node,
          actionElement: node,
          canAdd,
          canEdit,
          canRemove,
          data: { ...this.state.data },
          originalData: { ...this.state.originalData }
        }, () => {
          console.log("[TREE DEBUG] setState callback - state updated with data");
        });
      } else {
        console.log("[TREE DEBUG] Calling setState without data update");
        this.setState({
          cursor: node,
          actionElement: node,
          canAdd,
          canEdit,
          canRemove
        });
      }
    }

    // Navigate to the element - skip setControlsVisibility since we already set the values
    this.openActiveElement(node, true);

    if (isUpdated) {
      PubSub.publish(eventNames.treeUpdated, this.state.data.children);
    }
  }

  async openActiveElement(node, skipControlsVisibility = false) {
    const { history } = this.props;
    if (!node) {
      const { cursor } = this.state;
      node = cursor;
    }
    let projectId = node.projectID;
    if (!projectId) {
      projectId = this.state.projectId;
    }
    let queryParams = "";
    if (node.groupID) {
      queryParams = `?project=${projectId}&group=${node.groupID}`;
    } else {
      queryParams = `?project=${projectId}`;
      try {
        if (this.state.data && this.state.data.children && this.state.data.children.length > 0) {
          this.state.data.children.forEach(child => {
            if (child.id === projectId) {
              if (child.children && child.children.length > 0) {
                child.children.forEach(grandChild => {
                  if (
                    grandChild.contentType &&
                    node.elementType &&
                    grandChild.contentType.toLowerCase() === node.elementType.toLowerCase()
                  ) {
                    queryParams = `?project=${projectId}&group=${grandChild.id}`;
                  }
                });
              }
            }
          });
        }
      } catch (e) {}
    }
    // Only call setControlsVisibility if not already set by onToggle
    if (!skipControlsVisibility) {
      this.setControlsVisibility(node);
    }
    if (!node.children) {
      if (node.elementType === treeElementTypes.dataSource) {
        history.push(`/tables/${node.groupID}:${node.id}`);
      }

      if (node.elementType === treeElementTypes.flow) {
        // Navigate first, then publish event after navigation to prevent cascading renders
        history.push(`/work-flows/${node.id}${queryParams}`);
        // Defer PubSub to next frame to allow route change to settle
        requestAnimationFrame(() => {
          PubSub.publish(eventNames.showUpdatedFlowData);
        });
      }

      if (node.elementType === treeElementTypes.connection) {
        // Navigate first, then publish event after navigation to prevent cascading renders
        history.push(`/work-connections/${node.id}${queryParams}`);
        // Defer PubSub to next frame to allow route change to settle
        requestAnimationFrame(() => {
          PubSub.publish(eventNames.showUpdatedFlowData);
        });
      }

      if (node.elementType === treeElementTypes.script) {
        history.push(`/scripts/${node.id}${queryParams}`);
      }
      if (node.elementType === treeElementTypes.report) {
        if (node.name === "Automation Cost Saving") {
          history.push(`/metrics/cost-saving/${node.id}${queryParams}`);
        } else if (node.name === "Automation Test Creation") {
          history.push(`/metrics/test-creation/${node.id}${queryParams}`);
        } else if (node.name === "Result Mapper") {
          history.push(`/reports/automationResult/${node.id}${queryParams}`);
        }
      }

      if (node.elementType === treeElementTypes.component) {
        history.push(`/components/${node.id}${queryParams}`);
      }
      if (node.name === "Runtime Variable") {
        history.push(`/uservariables/runtimeVariable/${node.id}${queryParams}`);
      } else if (node.elementType === treeElementTypes.projectuser) {
        history.push(`/uservariables/${node.id}${queryParams}`);
      }

      if (node.elementType === treeElementTypes.api) {
        history.push(`/api/${node.id}${queryParams}`);
        requestAnimationFrame(() => {
          PubSub.publish(eventNames.apiModuleSelected);
          PubSub.publish(eventNames.responsejsonEditorReload, { data: "" });
          PubSub.publish(eventNames.selectRequestTab);
        });
      }

      if (node.elementType === treeElementTypes.graphql) {
        history.push(`/graphql/${node.id}${queryParams}`);
      }

      if (node.elementType === treeElementTypes.crawler) {
        history.push(`/crawlers/${node.id}${queryParams}`);
      }
    }
  }

  checkIsFile = nodeType => {
    const type = [
      treeElementTypes.dataSource,
      treeElementTypes.flow,
      treeElementTypes.connection,
      treeElementTypes.script,
      treeElementTypes.component,
      treeElementTypes.projectuser,
      treeElementTypes.api,
      treeElementTypes.graphql,
      treeElementTypes.crawler
    ];
    return type.some(item => item === nodeType);
  };

  setControlsVisibility(node = this.state.cursor) {
    if (!this._isMounted) return;

    let canAdd = false;
    let canEdit = false;
    let canRemove = false;

    if (node.elementType === treeElementTypes.root) {
      canAdd = true;
    } else if (node.elementType === treeElementTypes.project) {
      canEdit = true;
      canRemove = true;
    } else if (node.elementType === treeElementTypes.group) {
      canAdd = true;
      canEdit = true;
    } else if (this.checkIsFile(node.elementType)) {
      canEdit = true;
      canRemove = true;
    } else if (
      node.elementType === treeElementTypes.script ||
      node.elementType === treeElementTypes.flow ||
      node.elementType === treeElementTypes.connection ||
      node.elementType === treeElementTypes.api ||
      node.elementType === treeElementTypes.graphql ||
      node.elementType === treeElementTypes.projectuser
    ) {
      canAdd = true;
      canEdit = true;
      canRemove = true;
    }

    // Only update state if values actually changed to prevent unnecessary re-renders
    if (
      this.state.canAdd !== canAdd ||
      this.state.canEdit !== canEdit ||
      this.state.canRemove !== canRemove
    ) {
      this.setState({ canAdd, canEdit, canRemove });
    }
  }

  find(query) {
    if (!query) {
      return this.loadData();
    }
    let filtered = filters.filterTree(this.state.originalData, query);
    filtered = filters.expandFilteredNodes(filtered, query);
    if (this._isMounted) {
      this.setState({ data: filtered });
    }
  }

  shareUsers(userIds, projectId = this.state.cursor.projectID) {
    return this.apiService.post(`${apiUrlConfig.projects(projectId)}/share`, { userIds });
  }

  onEnableNode() {
    const cursor = this.state.cursor;
    let projectId = cursor.projectID;
    let projects = this.state.data;
    let projectChildren = projects.children.filter(p => p.id === projectId)[0].children;
    let userVariables = projectChildren.filter(c => c.name === "Variables")[0].children;
    let userVariablesWithoutCursor = userVariables.filter(v => v.id !== cursor.id);
    let isEnableVariable = false;
    let enableVariableName = null;
    if (userVariablesWithoutCursor && userVariablesWithoutCursor.length > 0) {
      for (let i = 0; i < userVariablesWithoutCursor.length; i++) {
        let variable = userVariablesWithoutCursor[i];
        if (variable && variable.isEnable && variable.isEnable === true) {
          isEnableVariable = true;
          enableVariableName = variable.name;
          break;
        }
      }
    }
    if (isEnableVariable) {
      toast.error(
        enableVariableName +
          " already enable, please try to disable " +
          enableVariableName +
          " and enable " +
          cursor.name
      );
    } else {
      this.onEnableDisableNode();
    }
  }

  onEnableDisableNode() {
    const cursor = this.state.cursor;
    let url, body;
    if (cursor.elementType === treeElementTypes.projectuser) {
      url = "/uservariables/" + cursor.id + "/enable";
      body = {};
    }
    LoaderService.show();
    this.apiService.post(url, body).then(res => {
      if (res.success) {
        PubSub.publish("refreshProject");
        // this.loadData();
        this.handleEnableDisableVariable(cursor);
        toast.success(cursor.name + " successfully updated!");
      } else {
        showErrMessage(res);
      }
      LoaderService.hide();
    });
  }

  handleEnableDisableVariable(cursor) {
    let projectId = cursor.projectID;
    let projects = this.state.data;
    let projectChildren = projects.children.filter(p => p.id === projectId)[0].children;
    let userVariables = projectChildren.filter(c => c.name === "Variables")[0].children;
    let userVariablesWithoutCursor = userVariables.filter(v => v.id === cursor.id);
    if (userVariablesWithoutCursor && userVariablesWithoutCursor.length > 0) {
      for (let i = 0; i < userVariablesWithoutCursor.length; i++) {
        let variable = userVariablesWithoutCursor[i];
        variable.isEnable = !variable.isEnable;
      }
    }
    if (this._isMounted) {
      this.setState({
        data: projects
      });
    }
    PubSub.publish(eventNames.treeUpdated, projects.children);
  }

  onDisableNode() {
    this.onEnableDisableNode();
  }

  onAddNode() {
    const cursor = this.state.cursor;
    if (
      cursor.elementType === treeElementTypes.group ||
      cursor.elementType === treeElementTypes.script ||
      cursor.elementType === treeElementTypes.api ||
      cursor.elementType === treeElementTypes.graphql ||
      cursor.elementType === treeElementTypes.flow ||
      cursor.elementType === treeElementTypes.connection ||
      cursor.elementType === treeElementTypes.projectuser
    ) {
      if (this._isMounted) {
        this.setState({
          modalShow: true,
          addFile: true,
          modalTitle: "",
          actionElement: this.state.cursor
        });
      }
    } else {
      if (this._isMounted) {
        this.setState({
          modalShow: true,
          addFolder: true,
          modalTitle: "",
          actionElement: this.state.cursor
        });
      }
    }
  }

  onCopyNode() {
    const cursor = this.state.cursor;
    if (
      cursor.elementType === treeElementTypes.group ||
      cursor.elementType === treeElementTypes.script ||
      cursor.elementType === treeElementTypes.flow ||
      cursor.elementType === treeElementTypes.connection ||
      cursor.elementType === treeElementTypes.api ||
      cursor.elementType === treeElementTypes.graphql ||
      cursor.elementType === treeElementTypes.projectuser ||
      this.checkIsFile(cursor.elementType)
    ) {
      if (this._isMounted) {
        this.setState({
          modalShow: true,
          copyFile: true,
          modalTitle: "",
          actionElement: this.state.cursor
        });
      }
    }
  }

  onDeleteNode() {
    console.log('[TheTree] 🗑️ onDeleteNode called, cursor:', this.state.cursor ? { id: this.state.cursor.id, name: this.state.cursor.name, elementType: this.state.cursor.elementType } : null);
    if (this._isMounted) {
      this.setState({
        modalShow: true,
        removeFolder: true,
        modalTitle: "",
        actionElement: this.state.cursor
      });
    }
  }

  onDeleteAllNode() {
    if (this._isMounted) {
      this.setState({
        modalShow: true,
        removedAll: true,
        modalTitle: "",
        actionElement: this.state.cursor
      });
    }
  }

  onProjectSettings() {
    const cursor = this.state.cursor;
    if (cursor && cursor.elementType === "PROJECT" && cursor.id) {
      window.location.href = `/project-settings/${cursor.id}?project=${encodeURIComponent(cursor.name || '')}`;
    }
  }

  onEditNode() {
    const cursor = this.state.cursor;
    if (cursor.params && cursor.params.userId && cursor.params.userId !== AuthService.user.id) {
      const tostId = `toastId${cursor.id}`;
      if (toast.isActive(this[tostId])) return;
      return (this[tostId] = toast.error("You can't assign users for projects that you didn't create."));
    }
    if (
      cursor.elementType === treeElementTypes.component ||
      cursor.elementType === treeElementTypes.dataSource ||
      cursor.elementType === treeElementTypes.script ||
      cursor.elementType === treeElementTypes.api ||
      cursor.elementType === treeElementTypes.graphql ||
      cursor.elementType === treeElementTypes.projectuser ||
      cursor.elementType === treeElementTypes.connection ||
      cursor.elementType === treeElementTypes.flow ||
      cursor.elementType === treeElementTypes.virtualization
    ) {
      if (this._isMounted && cursor.elementType === treeElementTypes.flow) {
        this.setState({
          modalShow: true,
          editFile: true,
          modalTitle: "Git Flow",
          actionElement: this.state.cursor
        });
      }
      if (this._isMounted && cursor.elementType === treeElementTypes.virtualization) {
        this.setState({
          modalShow: true,
          editFile: true,
          modalTitle: "Virtualization",
          actionElement: this.state.cursor
        });
      }
    } else {
      if (this._isMounted) {
        this.setState({
          modalShow: true,
          editFolder: true,
          modalTitle: "Assign user",
          actionElement: this.state.cursor
        });
      }
    }
  }

  addNode(result) {
    let url = "",
      cursor = this.state.cursor,
      //goTo = "",
      body = {};
    if (result.groupType === treeElementTypes.component) {
      result.groupType = "";
    }
    if (cursor.elementType === treeElementTypes.root) {
      url = "/projects";
      body = {
        name: result.name
      };
    }
    this.apiService.post(url, body).then(res => {
      if (res.success) {
        if (res.payload !== null) {
          const resProjectNode = res.payload.node;
          resProjectNode.children.forEach(child => {
            child.projectID = resProjectNode.id;
            if (child.name === "Variables" && Array.isArray(child.children)) {
              child.children.forEach(variableChild => {
                variableChild.projectID = resProjectNode.id;
              });
            }
          });

          // Create new object references to trigger React re-render
          const newChildren = [...(this.state.originalData.children || []), resProjectNode];
          const newOriginalData = {
            ...this.state.originalData,
            children: newChildren
          };

          if (this._isMounted) {
            this.setState({
              isCreatedProject: true,
              originalData: newOriginalData,
              data: newOriginalData,
              addedNodeId: res.payload.id
            });
          }
          this.activateAddedNode();
          if (cursor.elementType === treeElementTypes.root) {
            return this.shareUsers(result.userIds, res.payload.id).then(res => {
              if (res.success) {
                this.closeModal();
                const message = "Project successfully created!";
                toast.success(message);
              } else {
                this.closeModal();
                showErrMessage(res);
              }
            });
          }
        }
      } else {
        showErrMessage(res);
      }
    });
  }

  addBulkApis = async (apiObj, commonHeaders, graphqlApis) => {
    try {
      LoaderService.showTreeComLoading();
      const { cursor } = this.state;
      const isGraphqlGroup = cursor.contentType === "graphql";

      let restCount = 0;
      let gqlCount = 0;

      // Warn about skipped items in mixed collections
      if (isGraphqlGroup && apiObj && apiObj.length > 0) {
        toast.info(`${apiObj.length} REST request(s) skipped — this is a GraphQL group.`);
      }
      if (!isGraphqlGroup && graphqlApis && graphqlApis.length > 0) {
        toast.info(`${graphqlApis.length} GraphQL request(s) skipped — this is a REST API group.`);
      }

      // Create REST APIs (only if in a REST group)
      if (!isGraphqlGroup && apiObj && apiObj.length > 0) {
        const body = apiObj.map(obj => ({
          ...obj,
          api: { ...obj.api, groupId: cursor.id }
        }));

        const res = await this.apiService.post(apiUrlConfig.api_bulk_insert(), body);
        if (res.success) {
          restCount = res.payload ? res.payload.length : apiObj.length;
          // Create saved header from common headers if any
          if (commonHeaders && commonHeaders.length > 0 && cursor.parentNodeId) {
            try {
              const projectId = this.getProjectIdFromCursor(cursor);
              if (projectId) {
                const headerRequest = {
                  name: "Postman_Headers",
                  projectId: projectId,
                  apiId: res.payload && res.payload[0] ? res.payload[0].id : null,
                  headers: commonHeaders
                };
                await this.apiService.post(apiUrlConfig.api_header_save(), headerRequest);
                console.log("[POSTMAN] Saved common headers:", commonHeaders.length);
              }
            } catch (e) {
              console.warn("[POSTMAN] Could not save common headers:", e.message);
            }
          }
        } else {
          toast.error(res.error?.description || "Failed to create REST APIs.");
        }
      }

      // Create GraphQL APIs (only if in a GraphQL group)
      if (isGraphqlGroup && graphqlApis && graphqlApis.length > 0) {
        const gqlBody = graphqlApis.map(gql => ({
          ...gql,
          groupId: cursor.id
        }));

        const gqlRes = await this.apiService.post(apiUrlConfig.graphql_api_bulk_insert(), gqlBody);
        if (gqlRes.success) {
          gqlCount = gqlRes.payload ? gqlRes.payload.length : graphqlApis.length;
        } else {
          toast.error(gqlRes.error?.description || "Failed to create GraphQL APIs.");
        }
      }

      if (restCount > 0 || gqlCount > 0) {
        this.closeModal();
        // Clear lazy-load cache so new APIs appear
        if (this.state.data?.children) {
          this.state.data.children.forEach(project => {
            if (project.params) {
              project.params.childrenLoaded = false;
              project.children = [];
            }
          });
        }
        const label = isGraphqlGroup ? `${gqlCount} GraphQL` : `${restCount} REST`;
        setTimeout(() => {
          this.loadData(true, `${label} APIs created!`);
        }, 1000);
      } else {
        const targetType = isGraphqlGroup ? "GraphQL" : "REST";
        toast.warn(`No ${targetType} requests found in this collection.`);
      }
    } catch (error) {
      toast.error("Something went wrong while creating APIs.");
      console.error(error);
    } finally {
      LoaderService.hide();
      LoaderService.hideTreeComLoading();
    }
  };

  getProjectIdFromCursor = (cursor) => {
    const findNodeById = (nodes, id) => {
      if (!nodes) return null;
      for (const n of nodes) {
        if (n.id === id) return n;
        if (n.children) {
          const found = findNodeById(n.children, id);
          if (found) return found;
        }
      }
      return null;
    };

    let node = cursor;
    while (node) {
      if (node.elementType === "project") return node.id;
      if (node.parentNodeId && this.state.data?.children) {
        node = findNodeById(this.state.data.children, node.parentNodeId);
        if (!node) break;
      } else {
        break;
      }
    }
    return null;
  };

  addPostmanVariables = async variableObj => {
    try {
      LoaderService.showTreeComLoading();
      const { cursor } = this.state;
      const body = {
        ...variableObj,
        groupId: cursor.id
      };

      const res = await this.apiService.post(apiUrlConfig.projectusers_add_with_variables(), body);
      if (res.success) {
        this.closeModal();
        this.handleAfterSaveData(res, cursor);
      } else {
        if (res.error && res.error.description) {
          toast.error((res.error && res.error.description) || "Something went wrong.");
        } else {
          toast.error("Something went wrong while creating variables.");
        }
      }
    } catch (error) {
      toast.error("Something went wrong while creating variables.");
      console.error(error);
    } finally {
      LoaderService.hide();
      LoaderService.hideTreeComLoading();
    }
  };

  getAddRequestParams(result, cursor) {
    const configMap = {
      [treeElementTypes.dataSource.toLowerCase()]: {
        url: "/datasources",
        frontendurl: "/datasources",
        body: (result, cursor) => ({
          content: "[]",
          groupId: cursor.id,
          name: result.name
        })
      },
      [treeElementTypes.flow.toLowerCase()]: {
        url: "/flows",
        frontendurl: "/work-flows",
        body: (result, cursor) => ({
          name: result.name,
          groupId: cursor.id
        })
      },
      [treeElementTypes.connection.toLowerCase()]: {
        url: "/connections",
        frontendurl: "/work-connections",
        body: (result, cursor) => ({
          name: result.name,
          groupId: cursor.id
        })
      },
      [treeElementTypes.script.toLowerCase()]: {
        url: "/scripts",
        frontendurl: "/scripts",
        body: (result, cursor) => ({
          name: result.name,
          groupId: cursor.id
        })
      },
      [treeElementTypes.api.toLowerCase()]: {
        url: "/api",
        frontendurl: "/api",
        body: (result, cursor) => ({
          name: result.name,
          groupId: cursor.id
        })
      },
      [treeElementTypes.component.toLowerCase()]: {
        url: "/components",
        frontendurl: "/components",
        body: (result, cursor) => ({
          name: result.name,
          groupId: cursor.id
        })
      },
      [treeElementTypes.user.toLowerCase()]: {
        url: "/uservariables",
        frontendurl: "/uservariables",
        body: (result, cursor) => ({
          name: result.name,
          isGlobal: result.isGlobal,
          groupId: cursor.id
        })
      },
      [treeElementTypes.report.toLowerCase()]: {
        url: "/reports",
        frontendurl: "/reports",
        body: (result, cursor) => ({
          name: result.name,
          isGlobal: result.isGlobal,
          groupId: cursor.id
        })
      },
      [treeElementTypes.graphql.toLowerCase()]: {
        url: "/graphql-api",
        frontendurl: "/graphql",
        body: (result, cursor) => ({
          name: result.name,
          groupId: cursor.id
        })
      },
      [treeElementTypes.crawler.toLowerCase()]: {
        url: "/crawlers",
        frontendurl: "/crawlers",
        body: (result, cursor) => ({
          name: result.name,
          groupId: cursor.id,
          url: result.url || "",
          pageLimit: result.pageLimit || 20,
          requireAuth: !!result.requireAuth
        })
      }
    };
    const contentTypeKey = result.contentType.toLowerCase();

    if (configMap.hasOwnProperty(contentTypeKey)) {
      const config = configMap[contentTypeKey];
      const url = config.url;
      const frontendurl = config.frontendurl;
      const body = config.body(result, cursor);
      return { url, frontendurl, body };
    }
  }

  async addFile(result) {
    try {
      const cursor = this.state.cursor;
      await this.onToggle(cursor, true);
      const { url, frontendurl, body } = this.getAddRequestParams(result, cursor);
      const res = await this.apiService.post(url, body);
      if (res.success) {
        if (cursor && cursor.toggled === false) {
          cursor.toggled = true;
          cursor.active = true;
        }
        this.closeModal();

        if (!cursor.groupID && res.payload && res.payload.group) {
          cursor.groupID = res.payload.group.id;
          if (this._isMounted) {
            this.setState({ cursor: cursor });
          }
        }

        if (res.payload !== null && res.payload.group) {
          if (this._isMounted) {
            this.setState({
              projectId: res.payload.group.project.id
            });
          }
          const message =
            this.getElementName(
              this.state.cursor.contentType === treeElementTypes.connection.toLowerCase()
                ? "Database"
                : this.state.cursor.contentType
            ) + " successfully created!";

          if (message !== null) {
            toast.success(message);
          }

          this.handleAfterSaveData(res, cursor);

          setTimeout(() => {
            if (frontendurl.includes("api")) {
              PubSub.publish(eventNames.resetResponse);
              PubSub.publish(eventNames.publishApiFormReset);
            }
            dispatch({
              type: "site-map-url-change",
              url: frontendurl
            });
          }, 500);
        }
      } else {
        showErrMessage(res);
      }
    } catch (e) {
      showErrMessage(e);
    }
  }

  async getChildrenForComponentsAndApis(node, id) {
    if (!node.contentType && node.elementType) {
      node.contentType = node.elementType;
    }
    if (
      (node &&
        node.elementType === treeElementTypes.group &&
        node.projectID &&
        node.contentType.toLowerCase() === "component") ||
      node.contentType.toLowerCase() === "api"
    ) {
      let result = await this.apiService.get(apiUrlConfig.projectByIdAndContentType(node.projectID, node.contentType));
      let children = result && result.payload ? result.payload : [];

      let foundComponent;

      children.forEach(file => {
        file.projectID = node.projectID;
        file.groupID = node.groupID;

        if (file.id === id) {
          foundComponent = file;
        }
      });

      return foundComponent;
    }

    return undefined;
  }

  async handleAfterSaveData(res, cursor) {
    if (this._isMounted) {
      this.setState({ addedNodeId: res.payload.id });
    }

    let originalData = this.state.originalData;

    const rest = await this.getChildrenForComponentsAndApis(cursor, res.payload.id);
    // Determine the content type, handling null case
    const nodeContentType = cursor.contentType || cursor.elementType || '';
    const newChildNode = {
      id: res.payload.id,
      name: res.payload.name,
      elementType:
        nodeContentType.toLowerCase() === treeElementTypes.user.toLowerCase()
          ? treeElementTypes.projectuser
          : nodeContentType.toUpperCase() || cursor.elementType,
      hasContent: false,
      groupID: cursor.id,
      projectID: cursor.projectID || res.payload.projectId,
      ...rest
    };

    const addNewChildNode = (children, cursorId, newChildNode) => {
      for (let i = 0; i < children.length; i++) {
        if (children[i].id === cursorId) {
          if (newChildNode && newChildNode.elementType === "USERVARIABLE") {
            const currentChildren = children[i].children || [];
            const newChildren = [...currentChildren];

            if (currentChildren.length > 0) {
              const lastChild = newChildren.pop();
              newChildren.push(newChildNode, lastChild);
            } else {
              newChildren.push(newChildNode);
            }

            children[i].children = newChildren;
          } else {
            if (children[i].children && children[i].children.length > 0) {
              for (let j = 0; j < children[i].children.length; j++) {
                let comp = children[i].children[j];
                if (comp.active) {
                  delete comp.active;
                }
              }
            }
            children[i].children = children[i].children ? [...children[i].children, newChildNode] : [newChildNode];
          }
          return true;
        }
        if (children[i].children && addNewChildNode(children[i].children, cursorId, newChildNode)) {
          return true;
        }
      }
      return false;
    };

    addNewChildNode(originalData.children, cursor.id, newChildNode);

    if (this._isMounted) {
      this.setState(
        {
          data: originalData,
          originalData: originalData
        },
        () => {
          this.activateAddedNode();
          this.setControlsVisibility({});
          PubSub.publish(eventNames.treeUpdated, originalData.children);
        }
      );
    }
  }

  async handleAfterCopyData(res, cursor) {
    if (this._isMounted) {
      this.setState({ addedNodeId: res.payload.id });
    }
    let originalData = this.state.originalData;
    // Create a group-like node for getChildrenForComponentsAndApis since cursor is the copied component
    const groupNode = {
      elementType: treeElementTypes.group,
      projectID: cursor.projectID,
      groupID: cursor.groupID,
      contentType: cursor.elementType || cursor.contentType
    };
    const rest = await this.getChildrenForComponentsAndApis(groupNode, res.payload.id);
    // Determine the content type, handling null case
    const cursorContentType = cursor.contentType || cursor.elementType || '';
    const newChildNode = {
      id: res.payload.id,
      name: res.payload.name,
      elementType:
        cursorContentType.toLowerCase() === treeElementTypes.user.toLowerCase()
          ? treeElementTypes.projectuser
          : cursorContentType.toUpperCase() || cursor.elementType,
      hasContent: false,
      groupID: cursor.groupID,
      projectID: cursor.projectID || res.payload.projectId,
      ...rest
    };

    const addNewChildNode = (children, cursorId, newChildNode) => {
      for (let i = 0; i < children.length; i++) {
        if (children[i].id === cursorId) {
          if (newChildNode && newChildNode.elementType === "USERVARIABLE") {
            const currentChildren = children[i].children || [];
            const newChildren = [...currentChildren];

            if (currentChildren.length > 0) {
              const lastChild = newChildren.pop();
              newChildren.push(newChildNode, lastChild);
            } else {
              newChildren.push(newChildNode);
            }

            children[i].children = newChildren;
          } else {
            if (children[i].children && children[i].children.length > 0) {
              for (let j = 0; j < children[i].children.length; j++) {
                let comp = children[i].children[j];
                if (comp.active) {
                  delete comp.active;
                }
              }
            }
            // children = children ? [...children, newChildNode] : [newChildNode];
            if (!children) {
              children = [];
            }
            children.push(newChildNode);
            return true;
          }
          return true;
        }
        if (children[i].children && addNewChildNode(children[i].children, cursorId, newChildNode)) {
          return true;
        }
      }
      return false;
    };

    addNewChildNode(originalData.children, cursor.id, newChildNode);

    if (this._isMounted) {
      this.setState(
        {
          data: originalData,
          originalData: originalData
        },
        () => {
          this.activateAddedNode();
          this.setControlsVisibility({});
          PubSub.publish(eventNames.treeUpdated, originalData.children);
        }
      );
    }
  }

  editFile(result) {
    let url = "",
      cursor = this.state.cursor,
      body = {};
    if (result.elementType === treeElementTypes.dataSource) {
      url = "/datasources";
      body = {
        groupId: cursor.id,
        name: result.name
      };
    }
    if (result.elementType === treeElementTypes.flow) {
      url = "/flows";
      body = {
        name: result.name,
        groupId: cursor.id
      };
    }
    if (result.elementType === treeElementTypes.connection) {
      url = "/connections";
      body = {
        name: result.name,
        groupId: cursor.id
      };
    }
    if (result.elementType === treeElementTypes.script) {
      url = "/scripts";
      body = {
        name: result.name,
        groupId: cursor.id
      };
    }
    if (result.elementType === treeElementTypes.api) {
      url = "/api";
      body = {
        name: result.name,
        groupId: cursor.id
      };
    }
    if (result.elementType === treeElementTypes.component) {
      url = "/components";
      body = {
        name: result.name,
        groupId: cursor.id
      };
    }
    if (result.contentType === treeElementTypes.user.toLowerCase()) {
      url = "/uservariables";
      body = {
        name: result.name,
        groupId: cursor.id
      };
    }

    LoaderService.show();
    this.apiService.put(url + `/${cursor.id}`, body).then(res => {
      if (res.success) {
        this.closeModal();
        this.loadData();
        if (res.payload.group) {
          this.openActiveElement({
            active: true,
            groupID: res.payload.group.id,
            id: res.payload.id,
            elementType: res.payload.group.type.toUpperCase(),
            name: res.payload.name,
            projectID: res.payload.group.project.id,
            toggled: true
          });
        }
        toast.success(this.getElementName(this.state.cursor.elementType) + " successfully updated!");
      } else {
        showErrMessage(res);
      }
      LoaderService.hide();
    });
  }

  async copyFile(result) {
    try {
      const { elementType, contentType, name } = result;
      const { cursor } = this.state;

      const getDatasourceId = async () => {
        // First try from dependencies
        if (cursor && cursor.dependencies) {
          const foundDatasource = cursor.dependencies.find(
            datasource => datasource.elementType.toLowerCase() === treeElementTypes.dataSource.toLowerCase()
          );

          if (foundDatasource && foundDatasource.id) {
            return foundDatasource.id;
          }
        }

        // If not found in dependencies and this is a component, fetch from API
        if (elementType.toLowerCase() === treeElementTypes.component.toLowerCase() && cursor?.id) {
          try {
            const componentData = await this.apiService.get(apiUrlConfig.components(cursor.id));
            if (componentData?.payload?.datasource?.id) {
              return componentData.payload.datasource.id;
            }
          } catch (err) {
            console.error("Failed to fetch component datasource:", err);
          }
        }

        return null;
      };

      const typeMap = {
        [treeElementTypes.flow.toLowerCase()]: {
          url: apiUrlConfig.copyFlow(cursor.id),
          type: treeElementTypes.flow.toLowerCase(),
          body: { name, groupId: cursor.groupID }
        },
        [treeElementTypes.script.toLowerCase()]: {
          url: apiUrlConfig.copyScript(cursor.id),
          type: treeElementTypes.script.toLowerCase(),
          body: { name, groupId: cursor.groupID }
        },
        [treeElementTypes.api.toLowerCase()]: {
          url: apiUrlConfig.copyApi(cursor.id),
          type: treeElementTypes.api.toLowerCase(),
          body: { name, groupId: cursor.groupID }
        },
        [treeElementTypes.user.toLowerCase()]: {
          url: apiUrlConfig.copyUservariable(cursor.id),
          type: treeElementTypes.user.toLowerCase(),
          body: { name, groupId: cursor.groupID }
        },
        [treeElementTypes.component.toLowerCase()]: {
          url: apiUrlConfig.copyComponent(cursor.id),
          type: treeElementTypes.component.toLowerCase(),
          body: {
            name,
            groupId: cursor.groupID,
            datasourceId: null // Will be set below for component type
          }
        },
        [treeElementTypes.connection.toLowerCase()]: {
          url: apiUrlConfig.copyConnection(cursor.id),
          type: treeElementTypes.connection.toLowerCase(),
          body: { name, groupId: cursor.groupID }
        },
        [treeElementTypes.projectuser.toLowerCase()]: {
          url: apiUrlConfig.copyUservariable(cursor.id),
          type: treeElementTypes.projectuser.toLowerCase(),
          body: { name, groupId: cursor.groupID }
        }
      };

      const lowerElementType = elementType.toLowerCase();
      const lowerContentType = contentType.toLowerCase();

      const selectedType = typeMap[lowerElementType] || typeMap[lowerContentType];

      if (!selectedType) {
        throw new Error("Invalid element or content type");
      }

      const { url, body } = selectedType;

      // For component copy, fetch datasourceId asynchronously
      if (lowerElementType === treeElementTypes.component.toLowerCase()) {
        body.datasourceId = await getDatasourceId();
        if (!body.datasourceId) {
          toast.error("Cannot copy component: datasource not found. Please try refreshing the page.");
          return;
        }
      }

      LoaderService.showTreeComLoading();

      const res = await this.apiService.post(url, body);

      if (res.success) {
        this.closeModal();

        if (res.payload.extractionActivitiesRemoved) {
          toast.warn('"Extract" activities are not copied!');
        }

        if (res.payload.group) {
          this.setState({ addedNodeId: res.payload.id }, async () => {
            const message =
              this.getElementName(lowerElementType === "connection" ? "Database" : lowerElementType) +
              " successfully duplicated!";
            PubSub.publish(eventNames.copyComponentRefreshProjects);
            // handleAfterCopyData adds the new node locally and activates it
            // This is sufficient - no need to call loadData which refetches everything
            await this.handleAfterCopyData(res, cursor);
            toast.success(message);
          });
        }
      } else if (!res.success && res.error && res.error.code && res.error.description) {
        if (res.error.description) {
          toast.error(res.error.description);
        }
      } else {
        showErrMessage(res);
      }
    } catch (error: any) {
      console.error("Error copying file:", error);
      const errMsg = error?.response?.data?.error?.description
          || error?.response?.data?.message
          || error?.message
          || "An error occurred while copying the file.";
      if (errMsg.toLowerCase().includes("exists") || errMsg.toLowerCase().includes("duplicate")) {
        toast.error(`Name already exists. Please choose a different name.`);
      } else {
        showErrMessage({ message: errMsg });
      }
    } finally {
      LoaderService.hide();
      LoaderService.hideTreeComLoading();
    }
  }

  deleteNode(accept) {
    let url = "";
    let goTo = null;
    let childName = null;
    const { cursor } = this.state;
    if (cursor.elementType === treeElementTypes.project) {
      url = "/projects";
      goTo = "/";
    } else if (cursor.elementType === treeElementTypes.dataSource) {
      url = "/datasources";
      goTo = "/tables";
    } else if (cursor.elementType === treeElementTypes.flow) {
      url = "/flows";
      goTo = "/work-flows";
      childName = "Flows";
    } else if (cursor.elementType === treeElementTypes.connection) {
      url = "/connections";
      goTo = "/work-connections";
      childName = "Connections";
    } else if (cursor.elementType === treeElementTypes.script) {
      url = "/scripts";
      goTo = "/scripts";
      childName = "Scripts";
    } else if (cursor.elementType === treeElementTypes.api) {
      PubSub.publish(eventNames.publishApiFormReset);
      url = "/api";
      goTo = "/api";
      childName = "Apis";
    } else if (cursor.elementType === treeElementTypes.component) {
      url = "/components";
      goTo = "/components";
      childName = "Components";
    } else if (cursor.elementType === treeElementTypes.projectuser) {
      url = "/uservariables";
      goTo = "/uservariables";
      childName = "Variables";
    }
    if (cursor.params && cursor.params.userId && cursor.params.userId !== AuthService.user.id) {
      return this.deleteFromSharedUsers(cursor.id);
    }
    if (accept) {
      console.log('🗑️ [DELETE] Calling API:', url + `/${cursor.id}`);
      this.apiService.delete(url + `/${cursor.id}`).then(res => {
        console.log('🗑️ [DELETE] API Response:', JSON.stringify(res, null, 2));
        if (res.success) {
          dispatch({ type: "site-map-url-change", url: "" });
          // Don't publish closeAllFiles here - it causes a blank screen flash
          // The handleAfterDeleteData function will handle navigation properly
          // PubSub.publish(eventNames.closeAllFiles);
          this.closeModal();
          const message =
            this.getElementName(cursor.elementType === treeElementTypes.connection ? "Database" : cursor.elementType) +
            " successfully removed!";
          // this.loadData(true, message);
          if (url === "/projects") {
            if (message !== null) {
              toast.success(message);
            }
            this.handleAfterDeleteData(res, cursor, url);
          } else if (childName) {
            let isExists = false;
            let projectID = cursor.projectID;
            if (message !== null) {
              toast.success(message);
            }
            this.handleAfterDeleteData(res, cursor, url);
            let p = this.state.originalData.children;
            let projectIndex = p.findIndex(f => f.id === projectID);
            if (projectIndex >= 0) {
              let project = p[projectIndex];
              let projectScriptIndex = project.children.findIndex(f => f.name === childName);
              let script = project.children[projectScriptIndex];
              if (script && script.children.length > 0) {
                isExists = true;
                this.props.history.push(
                  `${goTo}/${script.children[script.children.length - 1].id}?project=${cursor.projectID}&group=${cursor.groupID}`
                );
                this.onToggle(script.children[script.children.length - 1], true);
              } else {
                if (project.children[0].children && project.children[0].children.length > 0) {
                  isExists = true;
                  let component = project.children[0].children[project.children[0].children.length - 1];
                  this.props.history.push(
                    `/components/${component.id}?project=${cursor.projectID}&group=${cursor.groupID}`
                  );
                  this.onToggle(component, true);
                }
              }
            }
            PubSub.publish(eventNames.refreshProjects);
            // When a component is deleted, refresh any open flow pane so the
            // deleted component's card disappears immediately. The backend
            // cascade (ComponentService.removeComponentFromFlow) has already
            // stripped the component from the flow document, so re-fetching the
            // flow via getFlowData() now returns the cleaned flow.
            if (cursor.elementType === treeElementTypes.component) {
              PubSub.publish(eventNames.displayUpdateFlowData);
            }
            if (!isExists) {
              goTo && this.props.history.push(goTo);
              PubSub.publish(eventNames.lastComponentDeleted);
            }
          } else {
            goTo && this.props.history.push(goTo);
          }
        } else {
          // Close modal first, then show error message
          console.log('🗑️ [DELETE] Error response - closing modal and showing error:', res);
          this.closeModal();
          showErrMessage(res);
        }
      }).catch(err => {
        console.error('🗑️ [DELETE] API call failed with exception:', err);
        this.closeModal();
        toast.error('Delete failed: ' + (err.message || 'Unknown error'));
      });
    } else {
      this.closeModal();
    }
  }

  handleRemovedAllNode(accept) {
    let url = "";
    // let goTo = "";
    let childName = null;
    const { cursor } = this.state;
    const contentTypeUpper = (cursor.contentType || cursor.elementType || '').toUpperCase();
    if (contentTypeUpper === treeElementTypes.flow) {
      url = "/flows/delete-all";
      childName = "Flows";
    } else if (contentTypeUpper === treeElementTypes.connection) {
      url = "/connections/delete-all";
      childName = "Databases";
    } else if (contentTypeUpper === treeElementTypes.script) {
      url = "/scripts/delete-all";
      childName = "Scripts";
    } else if (contentTypeUpper === treeElementTypes.api) {
      PubSub.publish(eventNames.publishApiFormReset);
      url = "/api/delete-all";
      childName = "Apis";
    } else if (contentTypeUpper === treeElementTypes.component) {
      url = "/components/delete-all";
      childName = "Components";
    } else if (contentTypeUpper === treeElementTypes.user) {
      url = "/uservariables/delete-all";
      childName = "Variables";
    }

    if (accept) {
      console.log('🗑️ [DELETE-ALL] Calling API:', url + `/${cursor.id}`);
      this.apiService.delete(url + `/${cursor.id}`).then(res => {
        console.log('🗑️ [DELETE-ALL] API Response:', JSON.stringify(res, null, 2));
        if (res.success) {
          dispatch({ type: "site-map-url-change", url: "" });
          // Don't publish closeAllFiles here - it causes a blank screen flash
          // Navigate to welcome page to avoid showing deleted content
          this.props.history.push("/welcome");
          this.closeModal();

          // Force reload children for this project by clearing childrenLoaded flag
          // This ensures the tree fetches fresh data from the server
          const projectId = cursor.projectID;
          if (projectId && this.state.data?.children) {
            const project = this.state.data.children.find(p => p.id === projectId);
            if (project && project.params) {
              console.log('🗑️ [DELETE-ALL] Success - Clearing childrenLoaded flag for project:', project.name);
              project.params.childrenLoaded = false;
              project.children = []; // Clear stale children
            }
          }

          const message = `${childName} successfully removed`;
          this.loadData(true, message);
        } else {
          console.log('🗑️ [DELETE-ALL] Error response - closing modal and refreshing tree:', res);
          dispatch({ type: "site-map-url-change", url: "" });
          // Don't publish closeAllFiles here - it causes a blank screen flash
          // Navigate to welcome page to avoid showing deleted content
          this.props.history.push("/welcome");
          this.closeModal();

          // Force reload children for this project by clearing childrenLoaded flag
          // This ensures the tree fetches fresh data from the server
          const projectId = cursor.projectID;
          if (projectId && this.state.data?.children) {
            const project = this.state.data.children.find(p => p.id === projectId);
            if (project && project.params) {
              console.log('🗑️ [DELETE-ALL] Clearing childrenLoaded flag for project:', project.name);
              project.params.childrenLoaded = false;
              project.children = []; // Clear stale children
            }
          }

          // Refresh the tree to show current state (some items may have been
          // deleted). Dropped the parallel PubSub.publish(refreshProjects) —
          // that subscriber (FlowActivityPanel) fetches project data the
          // just-navigated /welcome page doesn't need, and it doubled the
          // wall-time of the failure toast for zero visible benefit.
          this.loadData(true, null);
          // Show error message after tree refresh is triggered
          showErrMessage(res);
        }
      });
    } else {
      this.closeModal();
    }
  }

  handleAfterDeleteData(res, cursor, url) {
    let originalData = this.state.originalData;
    for (let i = 0; i < originalData.children.length; i++) {
      let project = originalData.children[i];
      if (url === "/projects") {
        if (project.id === cursor.id) {
          originalData.children.splice(i, 1);
        }
      } else {
        for (let j = 0; j < project.children.length; j++) {
          let projectComp = project.children[j];
          for (let k = 0; k < projectComp.children.length; k++) {
            let data = projectComp.children[k];
            if (data.id === cursor.id) {
              projectComp.children.splice(k, 1);
            }
          }
        }
      }
    }
    if (this._isMounted) {
      this.setState(
        {
          data: originalData,
          originalData: originalData,
          // Reset cursor to root when deleting a project
          ...(cursor.elementType.toLowerCase() === "project" ? { cursor: originalData } : {})
        },
        () => {
          this.activateAddedNode();
          this.setControlsVisibility({});
          if (
            cursor.elementType.toLowerCase() === "project" ||
            cursor.elementType.toLowerCase() === "script" ||
            cursor.elementType.toLowerCase() === "api"
          ) {
            // Navigate to welcome page without full page reload
            this.props.history.push("/welcome");
            // Publish tree update event instead of window.location.reload()
            // This prevents the flicker/blank page issue
            PubSub.publish(eventNames.treeUpdated, originalData.children);
            PubSub.publish(eventNames.refreshProjects);
          } else {
            PubSub.publish(eventNames.treeUpdated, originalData.children);
          }
        }
      );
    }
  }

  async deleteFromSharedUsers(id) {
    const users = await this.apiService.get(`/projects/${id}`).then(res => res.payload);
    const newUsers = users.sharedUsers.filter(user => user !== AuthService.user.id);
    await this.shareUsers(newUsers, id);
    await this.closeModal();
    const message = this.getElementName(this.state.cursor.elementType) + " successfully removed!";
    await this.loadData(true, message);
    await PubSub.publish(eventNames.editeTreeName);
  }

  editNode(result) {
    let url = "",
      // goTo = "/",
      cursor = this.state.actionElement,
      body = {};
    if (result.groupType === treeElementTypes.component) {
      result.groupType = "";
    }
    if (cursor.elementType === treeElementTypes.project) {
      url = "/projects";
      // goTo = "/";
      body = {
        name: result.name
      };
    }
    if (cursor.elementType === treeElementTypes.projectuser) {
      url = "/uservariables";
      //goTo = "/uservariables";
      body = {
        name: result.name
      };
    }
    if (cursor.elementType === treeElementTypes.api) {
      url = "/api";
      //goTo = "/api";
      body = {
        name: result.name
      };
    }
    if (cursor.elementType === treeElementTypes.group) {
      url = "/groups";
      //goTo = "/";
      body = {
        name: result.name,
        projectId: cursor.id,
        type: result.groupType
      };
    }
    this.apiService.put(url + `/${cursor.id}`, body).then(projectRes => {
      if (projectRes.success) {
        if (cursor.elementType === treeElementTypes.project) {
          return this.shareUsers(result.userIds, projectRes.payload.id).then(res => {
            if (res.success) {
              this.closeModal();
              const message = "Project assigned successfully!";
              // this.loadData(true, message);
              if (message !== null) {
                toast.success(message);
              }
              let originalData = this.state.originalData;
              for (let i = 0; i < originalData.children.length; i++) {
                let oChildren = originalData.children[i];
                if (oChildren.id === projectRes.payload.id) {
                  if (!oChildren.params) {
                    oChildren.params = {};
                    oChildren.params["sharedUsers"] = [];
                  }
                  oChildren.params.sharedUsers = res.payload.users;
                }
              }
              if (this._isMounted) {
                this.setState(
                  {
                    data: originalData,
                    originalData: originalData
                  },
                  () => {
                    this.setControlsVisibility({});
                    PubSub.publish(eventNames.treeUpdated, originalData.children);
                  }
                );
              }
              // this.props.history.push(goTo);
            } else {
              showErrMessage(res);
            }
          });
        }
        this.closeModal();
      } else {
        showErrMessage(projectRes);
      }
    });
  }

  getModalContent = () => {
    const cursor = this.state.cursor;
    // Guard against undefined cursor or elementType
    const elementType = cursor?.elementType?.toLowerCase() || 'item';
    const cursorName = cursor?.name || '';
    let title = `Delete ${elementType} ${cursorName} ?`;
    if (cursor?.params?.userId && cursor.params.userId !== AuthService.user.id) {
      title = `Are you sure you want to remove yourself from ${cursorName}?`;
    }
    if (this.state.removedAll) {
      title = `Delete All ${cursorName}?`;
    }
    if (this.state.importPostmanCollectionModal) {
      return <PostmanCollectionUploader close={this.closeModal} save={this.addBulkApis} />;
    }

    if (this.state.importSwaggerFlowsModal) {
      return (
        <SwaggerFlowImporter
          groupId={cursor?.id}
          close={this.closeModal}
          save={this.onSwaggerFlowsCreated}
        />
      );
    }

    if (this.state.importPostmanVariablesModal) {
      return (
        <PostmanEnvironmentUploader
          close={this.closeModal}
          save={this.addPostmanVariables}
          groupId={cursor?.id}
          onConfigImported={this.onConfigImported}
        />
      );
    }

    if (
      this.state.addFolder ||
      this.state.editFolder ||
      this.state.addFile ||
      this.state.editFile ||
      this.state.copyFile
    )
      return (
        <TreeCreationModal
          {...this.state}
          modalTitle={this.state.modalTitle}
          save={this.modalSubmit}
          close={this.closeModal}
          setPostmanModal={this.setPostmanModalOpen}
          setSwaggerFlowModal={this.setSwaggerFlowModalOpen}
        />
      );
    if (this.state.removeFolder && this.state.cursor)
      return (
        <ConfirmAction
          id={cursor.id}
          type={cursor.elementType}
          title={title}
          actionToConfirm={this.modalSubmit.bind(this)}
          actionToDismiss={this.closeModal}
        />
      );
    if (this.state.removedAll && this.state.cursor) {
      return (
        <ConfirmAction title={title} actionToConfirm={this.modalSubmit.bind(this)} actionToDismiss={this.closeModal} />
      );
    }
    return null;
  };

  closeModal = () => {
    if (this._isMounted) {
      this.setState({
        modalShow: false,
        addFolder: false,
        addFile: false,
        editFolder: false,
        removeFolder: false,
        copyFile: false,
        removedAll: false,
        importPostmanCollectionModal: false,
        importPostmanVariablesModal: false,
        importSwaggerFlowsModal: false
      });
    }
  };

  modalSubmit = result => {
    const success = result;
    result = {
      ...result,
      contentType: this.state.actionElement.contentType
        ? this.state.actionElement.contentType
        : this.state.actionElement.elementType
        ? this.state.actionElement.elementType.toLowerCase()
        : this.state.actionElement.elementType,
      elementType: this.state.actionElement.elementType
    };
    if (this.state.addFolder) {
      this.addNode(result);
    } else if (this.state.addFile) {
      this.addFile(result);
    } else if (this.state.editFile) {
      this.editFile(result);
    } else if (this.state.editFolder) {
      this.editNode(result);
    } else if (this.state.removeFolder) {
      this.deleteNode(success);
    } else if (this.state.copyFile) {
      this.copyFile(result);
    } else if (this.state.removedAll) {
      this.handleRemovedAllNode(success);
    }
  };

  onWebSocketsChangeConnectedStatus = status => {
    if (this._isMounted) {
      this.setState(() => ({ webSocketsConnectedStatus: status }));
    }
    PubSub.publish("statusMessage", status);
  };

  getElementName(el) {
    if (!el) return;
    el = el.toLowerCase();
    el = el.charAt(0).toUpperCase() + el.slice(1);
    return el;
  }

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  handleClickOutside = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      document.removeEventListener("keyup", this.handleOnKeyUp);
    }
  };

  getSelectedElementData = (data, CursorId) => {
    let newActiveIndex = data.children.findIndex(item => item.id === CursorId);
    if (newActiveIndex < 0) {
      data.children.forEach(element => {
        if (element.children && element.children.length > 0) this.getSelectedElementData(element, CursorId);
      });
    } else {
      let newActiveData = data.children.find(item => item.id === CursorId);
      this.parentLevel = data;
      this.dataProvider = data.children;
      this.activeIndex = newActiveIndex;
      // Set this.cursor so getCursorById can find it
      this.cursor = newActiveData;
      if (this._isMounted) {
        this.setState({ cursor: newActiveData });
      }
      return;
    }
  };

  handleOnKeyUp(e) {
    if ([32, 37, 38, 39, 40].indexOf(e.keyCode) <= -1) return;

    e.preventDefault();
    e.stopPropagation();
    this.getSelectedElementData(this.state.data, this.state.cursor.id);
    this.activeNode = this.state.cursor;
    if (e.keyCode === 37 && this.parentLevel.elementType === "ROOT") {
      return;
    }

    if (e.keyCode === 37) {
      this.onToggle(this.parentLevel, false);
    } else if (e.keyCode === 40) {
      if (this.activeNode.toggled && this.activeNode.children && this.activeNode.children.length) {
        this.onToggle(this.activeNode.children[0], false);
      } else if (this.dataProvider.length - 1 > this.activeIndex) {
        this.onToggle(this.dataProvider[this.activeIndex + 1], false);
      } else {
        this.onToggle(this.dataProvider[0], false);
      }
    } else if (e.keyCode === 38) {
      if (this.activeIndex === 0) {
        this.onToggle(this.dataProvider[this.dataProvider.length - 1], false);
      } else {
        this.onToggle(this.dataProvider[this.activeIndex - 1], false);
      }
    } else if (e.keyCode === 13 || e.keyCode === 39) {
      this.onToggle(this.activeNode, this.activeNode.children && this.activeNode.children.length > 0);
    }
  }

  async handleTreeClick(e) {
    document.addEventListener("keyup", this.handleOnKeyUp);
    const id = e.target.parentNode.parentNode.getAttribute("data-id");
    const action = e.target.getAttribute("data-action");

    console.log('[TheTree] 🖱️ handleTreeClick called', {
      action,
      id,
      targetTagName: e.target.tagName,
      targetClassName: e.target.className,
      parentNode: e.target.parentNode?.tagName,
      grandparent: e.target.parentNode?.parentNode?.tagName,
      dataId: e.target.parentNode?.parentNode?.getAttribute?.("data-id")
    });

    if (this.state.isCreatedProject) {
      if (this._isMounted) {
        this.setState({ isCreatedProject: false });
      }
    }

    if (action) {
      console.log('[TheTree] 🎯 Action detected:', action, 'for id:', id);
      const actionsStop = () => {
        e.persist();
        e.preventDefault();
        e.stopPropagation();
      };

      let cursor;
      const nodeFind = node => {
        if (node.id === id) cursor = node;
        if (node.children) node.children.forEach(elem => nodeFind(elem));
      };
      nodeFind(this.state.data);
      console.log('[TheTree] 🔍 Found cursor:', cursor ? { id: cursor.id, name: cursor.name, elementType: cursor.elementType } : null);
      if (cursor) {
        cursor.active = true;

        actionsStop();

        if (this.state.cursor && this.state.cursor.id !== cursor.id) {
          this.deactivateCursor();
        }

        if (this._isMounted) {
          console.log('[TheTree] ✅ Calling action:', action);
          this.setState({ cursor }, async () => {
            await this.actions[action].call();
          });
        }
      } else {
        console.log('[TheTree] ❌ No cursor found for id:', id);
      }
    }
  }

  addProject = () => {
    if (this._isMounted) {
      this.setState(prevState => {
        // Ensure actionElement has elementType set to ROOT for project creation
        const actionElement = {
          ...prevState.data,
          elementType: prevState.data?.elementType || 'ROOT'
        };
        return {
          cursor: actionElement,
          modalShow: true,
          addFolder: true,
          modalTitle: "",
          actionElement: actionElement
        };
      });
    }
  };

  render() {
    return (
      <div className="aside-holder">
        <div className="tree-search-wrapper">
          <Search width="100%" placeholder="Search projects..." find={this.find} />
        </div>

        <div className="tree-panel">
          <div className="tree-panel-header">
            <span className="tree-panel-title">Projects</span>
            <button
              className="tree-panel-add-btn"
              title="Add New Project"
              onClick={() => this.addProject()}
              aria-label="Add new project"
            >
              <i className="fas fa-plus"></i>
            </button>
          </div>
          <div className="tree-panel-content" ref={this.setWrapperRef} onMouseUp={e => this.handleTreeClick(e)}>
            <Treebeard
              data={this.state.data}
              style={customTheme}
              decorators={decorators}
              animations={false}
              onToggle={this.onToggle}
            />
          </div>
        </div>

        <WebSockets onWebSocketsChangeConnectedStatus={status => this.onWebSocketsChangeConnectedStatus(status)} />

        {this.state.isNodeNameModal && (
          <NodeNameEditModal
            close={() => {
              if (this._isMounted) {
                this.setState({ isNodeNameModal: false });
              }
            }}
            nodeData={this.state.nodeData}
          />
        )}
        {/* Git Flow feature hidden - uncomment to re-enable
        {this.state.isGitFlowModal && (
          <GitFlowModal
            close={() => {
              if (this._isMounted) {
                this.setState({ isGitFlowModal: false });
              }
            }}
            nodeData={this.state.nodeData}
          />
        )}
        */}
        {/*{this.state.isVirtualization && (
            <VirtualizationModal
                close={() => {
                  if (this._isMounted) {
                    this.setState({ isVirtualization: false });
                  }
                }}
                nodeData={this.state.nodeData}
            />
        )}*/}
        {this.state.isGitLogModal && (
          <GitLogModal
            close={() => {
              if (this._isMounted) {
                this.setState({ isGitLogModal: false });
              }
            }}
            nodeData={this.state.nodeData}
          />
        )}
        {this.state.modalShow && <Modal>{this.getModalContent()}</Modal>}
      </div>
    );
  }
}

export default withRouter(TheTree);
